import dynamic from 'next/dynamic';
import type { FranchiseListSearch, FranchisePage } from 'interfaces/content/Ranking';
import type { GetStaticPaths, GetStaticProps } from 'next';
import type { MenuItemProps } from 'interfaces/navigation/Header';
import { getRankingStaticProps } from 'utils/miscUtils/getRankingStaticProps';

const SimpleRankingPage = dynamic(() => import('pages/SimpleRanking/SimpleRankingPage'));
const RankingCompanyFranchisePage = dynamic(() => import('pages/RankingCompanyFranchise/RankingCompanyFranchisePage'));

interface FranchisePageProps {
  franchise: FranchisePage;
  franchiseSearch: FranchiseListSearch;
  subMenu?: MenuItemProps[];
}

const RankingFranchiseNextPage = ({ franchise, subMenu, franchiseSearch }: FranchisePageProps) =>
  franchise.listType === 'grid' ? (
    <SimpleRankingPage franchiseList={franchise} />
  ) : (
    <RankingCompanyFranchisePage
      franchise={franchise}
      franchiseSearch={franchiseSearch}
      subMenu={subMenu}
    />
  );

export const getStaticProps: GetStaticProps = async (context) => {
  return getRankingStaticProps(context);
};

export const getStaticPaths: GetStaticPaths = () => {
  if (process.env.TEST) {
    return {
      fallback: 'blocking',
      paths: [
        {
          params: {
            franchiseSlug: '40-under-40',
          },
        },
        {
          params: {
            franchiseSlug: 'fortune500',
          },
        },
      ],
    };
  }

  return {
    fallback: 'blocking',
    paths: [
      {
        params: {
          franchiseSlug: 'fortune500',
        },
      },
      {
        params: {
          franchiseSlug: 'global500',
        },
      },
      {
        params: {
          franchiseSlug: 'asia-future',
        },
      },
    ],
  };
};

export default RankingFranchiseNextPage;
